import { DOCUMENT } from '@angular/common'
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core'
import { BehaviorSubject, distinctUntilChanged, shareReplay } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class FlyoutCommunicationService {
  private renderer: Renderer2

  constructor(rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {
    this.renderer = rendererFactory.createRenderer(null, null)
  }

  private showFlyout = new BehaviorSubject<boolean>(false)

  public readonly showFlyout$ = this.showFlyout.asObservable().pipe(distinctUntilChanged(), shareReplay(1))

  public setShowFlyoutValue(showFlyout: boolean): void {
    this.showFlyout.next(showFlyout)
    if (this.showFlyout.value) {
      this.renderer.setStyle(this.document.body, 'overflow', 'hidden')
      this.renderer.setStyle(this.document.body, 'touchAction', 'none')
    } else {
      this.renderer.setStyle(this.document.body, 'overflow', 'visible')
      this.renderer.setStyle(this.document.body, 'touchAction', 'auto')
    }
  }
}
